<template>
  <div class="product-head">
    <h2>{{lanInfo.banner01.title}}</h2>
    <p>{{lanInfo.banner01.content}}</p>
  </div>
</template>

<script>
export default {
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.news;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
}
</script>

<style scoped lang="scss">
.product-head {
  height: 418px;
  width: 100%;
  background: url(../../assets/images/product/productbg.png) center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    color: #fff;
    font-size: 48px;
    font-weight: normal;
  }

  p {
    color: #fff;
    font-size: 24px;
    margin-top: 40px;
  }
}
</style>